//
//
//
//
//
//

import faqSeoMixin from '@/mixins/faqSeoMixin'

export default {
  components: {
    desktop: () =>
      import(/* webpackChunkName:'views/faq/section' */ '@/views/faq/section.vue'),
    mobile: () =>
      import(/* webpackChunkName:'views/faq/m_section' */ '@/views/faq/m_section.vue')
  },
  mixins: [faqSeoMixin],
  scrollToTop: true,
  inheritAttrs: false,
  head() {
    return this.faqSeoHead(
      this.$seoTagBuilder({
        ...this.$i18nSeo(this.getDefaultMeta()),
        titleTemplate: `${this.$t('global.faq')} | %s`
      })
    )
  },
  computed: {
    renderViewType() {
      return this.$store.state.app.browserType
    }
  }
}
